import { CASES } from './constants';

/**
 * Action to update tags in the store.
 *
 * This action is dispatched to update the tags state in the Redux store.
 * It takes a payload containing the new tags' data.
 *
 * @param {Object} payload - The new tags data to be stored.
 * @returns {Object} The action object with type and payload.
 **/
export const updateTags = (payload) => {
    return { type: CASES.UPDATE_TAGS, payload };
};

/**
 * Action to update the tags filter form.
 *
 * This action is dispatched to update the filter form state in the Redux store.
 * It takes a key and data to update the specific field in the filter form.
 *
 * @param {string} key - The key of the filter form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @returns {Object} The action object with type and payload.
 **/
export const updateTagsFilterForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_TAGS_FILTER_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the tags filter form.
 *
 * This action is dispatched to reset the filter form state in the Redux store.
 * It clears all the fields in the filter form.
 *
 * @returns {Object} The action object with type and payload.
 **/
export const clearTags = () => {
    return { type: CASES.CLEAR_TAGS, payload: {} };
};
